import i18n from '@/app/i18n/global.js'
import Vue from 'vue'
import ElementLocale from 'element-ui/lib/locale';


/**
 * 
 * @param {请求参数} reqParams 
 * @param {*表格titleList详细参考device-manage下的titleList} list 
 * @param {*方法名} methods 
 * @param {*替换} replaceitems //列：{status: {'-1': this.$t('lang.offline'), 0: this.$t('lang.electricity'),'1': this.$t('lang.poweroutages'),},}
 * @param {*下载文件标题} doctitle //列：this.$t('lang.equipmentlist')
 */

Vue.prototype.$down = function (reqParams, list, methods, replaceitems = {}, title = null) {
    try {
        let newObj = JSON.parse(JSON.stringify(reqParams));
        let titleList = []
        list.map(item => {
            titleList.push({
                property: item.prop,
                propertyValue: this.$t(item.label)
            })
        })
        newObj.export = {
            filetype: 1,
            replaceitems: replaceitems,
            titleitems: titleList
        }

        newObj.pageSize = 99999;
        newObj.pageNum = 1;
        let date = new Date();
        // let title = i18n.t(doctitle);
        let fileName = title + date.getFullYear().toString() + '-' + (date.getMonth() + 1).toString() + '-' + date.getDate().toString() + ' ' + date.getHours().toString() + ':' + date.getMinutes().toString() + ':' + date.getSeconds().toString();
        this.$store.dispatch(methods, newObj).then(res => {
            let blob = new Blob([res], { type: "application/json" })
            let objectUrl = URL.createObjectURL(blob);
            var a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display:none');
            a.setAttribute('href', objectUrl);
            a.setAttribute('download', fileName + ".xls");
            a.click();
            URL.revokeObjectURL(objectUrl);
        }, error => {
            console.log("!", JSON.parse(error))
        })
    } catch (error) {
        console.log(error);
    }

}

Vue.prototype.$download = function (reqParams, list, methods, replaceitems = {}, title = null, pageSize = 99999) {
    try {
        let newObj = JSON.parse(JSON.stringify(reqParams));
        let titleList = []
        list.map(item => {
            titleList.push({
                property: item.prop,
                propertyValue: this.$t(item.label)
            })
        })
        newObj.export = {
            filetype: 1,
            replaceitems: replaceitems,
            titleitems: titleList
        }

        newObj.pageSize = pageSize;
        newObj.pageNum = 1;
        let date = new Date();
        // let title = i18n.t(doctitle);
        let fileName = title + date.getFullYear().toString() + '-' + (date.getMonth() + 1).toString() + '-' + date.getDate().toString() + ' ' + date.getHours().toString() + ':' + date.getMinutes().toString() + ':' + date.getSeconds().toString();
        this.$store.dispatch(methods, newObj).then(res => {
            if (res.success == 1) {
                this.$store.commit("showDownload", true)
            } else {
                console.error("下载失败");
            }
        }, error => {
            console.log("!", JSON.parse(error))
        })
    } catch (error) {
        console.log(error);
    }

}



/**
 * 
 * @param {*} e moduleId 权限id
 * @returns true 表示有权限  false 表示无权限
 */
Vue.prototype.$permission = function (e, showTip = true) {
    // console.log(this.$route);
    let ret = false;
    let roleList = localStorage.getItem("roleAuthory");
    let isSubAccount = localStorage.getItem("isSubAccount");
    // console.log(isSubAccount, roleList, !isSubAccount);
    if (isSubAccount == 'true') {
        let list = JSON.parse(roleList);
        list.map(item => {
            console.log(item.moduleId == e);
            if (item.moduleId == e) {
                ret = true;
            }
        })
        console.log(e, list, ret);
        // ret = false
        if (!ret && showTip) {
            Vue.prototype.$message.error(ElementLocale.t('lang.permissiontip'))
        }
        return ret;
    } else {
        return true;
    }

}

const myToFixed = function (decimals) {
    let numStr = this.toString();
    if (numStr == 'NaN') numStr = '0';
    const [integerPart, decimalPart] = numStr.split('.');
    let finalDecimalPart = decimalPart ? decimalPart : '';

    // 确保小数部分有足够位数，不足则补零
    while (finalDecimalPart.length < decimals) {
        finalDecimalPart += '0';
    }

    // 如果小数部分过长，进行四舍五入
    if (finalDecimalPart.length > decimals) {
        const roundingNeeded = finalDecimalPart[decimals];
        if (parseInt(roundingNeeded, 10) >= 5) {
            finalDecimalPart = (parseInt(finalDecimalPart.slice(0, decimals), 10) + 1).toString().padStart(decimals, '0');
        } else {
            finalDecimalPart = finalDecimalPart.slice(0, decimals);
        }
    }

    return `${integerPart}.${finalDecimalPart}`;
}
Number.prototype.toFixed = myToFixed;
String.prototype.toFixed = myToFixed;